import { Fragment } from 'react';

import { Box } from '@/components/Box';
import { getWarrantyOrderLineDetails } from '@/components/MyOrders/OrderCard/utils';
import type { MetadataItem } from '@/graphql/saleor/api';
import { getEngravingDetailsFromMetadata } from '@/lib/engraving';
import { getProductType } from '@/lib/product';

import { resolveOrderLineReturnFields } from '../helpers';
import { useOrderDetailsContext } from '../OrderDetailsContext';
import { OrderLineRow } from './OrderLineRow';

export function OrderLinesSection() {
  const {
    channelSlug,
    formatMessage,
    fulfillment,
    hasFulfillment,
    imageLoader,
    isMobileView,
    languageCode,
    order,
    orderLinesWithoutNulls: orderLines,
    sortedLines,
    taxMessage,
    type,
    voucherType,
    withdrawal,
  } = useOrderDetailsContext();

  const isReturnHistory = type === 'RETURNHISTORY';
  const isOrderHistory = type === 'ORDERHISTORY';
  const showLineReturnStatus = isOrderHistory || isReturnHistory;

  const isWithdrawalEligibilityLoading =
    withdrawal.isWithdrawalEligibilityLoading;
  const withdrawalEligibility = withdrawal.withdrawalEligibility;

  return (
    <Box paddingBottom={3} paddingTop={3}>
      {sortedLines.map((orderLine, index) => {
        const { productName, thumbnail } = getWarrantyOrderLineDetails(
          orderLine,
          orderLines,
          formatMessage,
        );

        const { cancelReturnComment, fulfillmentId, returnStatus } =
          resolveOrderLineReturnFields(orderLine, order, {
            fulfillmentId: fulfillment?.id,
            isReturnHistory,
          });

        const lineAlreadyInReturn = Boolean(fulfillmentId && returnStatus);
        const productType = getProductType(
          orderLine?.variant?.product?.productType,
        );
        const engravingDetails = getEngravingDetailsFromMetadata(
          orderLine.metadata as readonly MetadataItem[],
        );

        return (
          <Fragment key={`orderLine${index}-${orderLine.id}`}>
            {orderLine ? (
              <OrderLineRow
                cancelReturnComment={cancelReturnComment}
                channelSlug={channelSlug}
                engravingDetails={engravingDetails}
                formatMessage={formatMessage}
                fulfillmentId={fulfillmentId}
                hasFulfillment={hasFulfillment}
                imageLoader={imageLoader}
                index={index}
                isMobileView={isMobileView}
                isOrderHistory={isOrderHistory}
                isWithdrawalEligibilityLoading={isWithdrawalEligibilityLoading}
                languageCode={languageCode}
                lineAlreadyInReturn={lineAlreadyInReturn}
                orderChannelSlug={order.channel.slug}
                orderId={order.id}
                orderLine={orderLine}
                productName={productName}
                productType={productType}
                returnStatus={returnStatus}
                showLineReturnStatus={showLineReturnStatus}
                taxMessage={taxMessage}
                thumbnail={thumbnail}
                voucherType={voucherType}
                withdrawalEligibility={withdrawalEligibility}
              />
            ) : null}
          </Fragment>
        );
      })}
    </Box>
  );
}
